import { useAuth } from 'contexts/auth';
import InstructorViewAssignmentPage from 'pages/InstructorViewAssignment';
import StudentViewAssignmentPage from 'pages/StudentViewAssignment';

const ViewAssignmentPage = () => {
    const { auth } = useAuth();
    if (auth.role === 'instructor') return <InstructorViewAssignmentPage />;
    if (auth.role === 'ta') return <InstructorViewAssignmentPage />;
    if (auth.role === 'student') return <StudentViewAssignmentPage />;
    return null;
};

export default ViewAssignmentPage;
